<template>
  <div class="addOrders">
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/order' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加订单</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card">
      <el-form style="margin-top: 20px" ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="开通商品" prop="studentGroupId">
              <el-button type="primary" @click="openaddFormVisible">开通商品</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="下单对象">
              <el-select v-model="purchaserType" placeholder="请选择" @change="purchaserTypeChange">
                <el-option v-for="item in orderObjArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="20">
            <el-form-item label class="tabs">
              <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="subjectList" tooltip-effect="dark" style="width: 100%" border>
                <!-- <el-table-column show-overflow-tooltip prop="readyBuy" width="100" label="状态">
                <template slot-scope="row">
                  <span
                    class="mainColor"
                    :style="row.row.readyBuy==1?'color:rgb(36, 210, 181)':'color: #409EFF;'"
                  >{{row.row.readyBuy==1?"已购买":"未购买"}}</span>
                </template>
                </el-table-column>-->
                <el-table-column prop="name" show-overflow-tooltip label="商品" align="center">
                  <template slot-scope="row">
                    <el-row>
                      <!-- <el-col :span="8">
                        <span>
                          <img
                            style="margin-right:10px;"
                            width="100%"
                            height="44px"
                            :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                          />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      </el-col> -->
                      <el-col :span="8">
                        <span>
                          <img style="margin-right: 10px" height="60px" width="100%" :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          " />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span style="color: rgb(77, 148, 255); margin-left: 10px">{{ row.row.name }}</span>
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            ">￥{{ row.row.originalPrice }}</span>
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                  <template slot-scope="row">
                    <span style="display:block;">
                      <span style="color:red">￥{{row.row.price}}</span>
                      <span
                        style="text-decoration:line-through;color:rgb(162,170,188)"
                      >￥{{row.row.originalPrice}}</span>
                    </span>
                  </template>
                </el-table-column> -->

                <el-table-column width="150" align="center" prop="goodsCount" label="数量">
                  <template slot-scope="row">
                    <el-input v-if="
                      purchaserType == '代理人' && countIndex == row.$index
                    " v-model="row.row.goodsCount" @blur="changeCount(row.row)" min="1" ref="inputIndex" autofocus="true" type="number" placeholder="商品数量" size="mini"></el-input>
                    <p v-else style="color: red; font-weight: bold" @click="showCountInput(row)">
                      {{ row.row.goodsCount }}
                    </p>
                  </template>
                </el-table-column>

                <el-table-column show-overflow-tooltip width="150" prop="agentPrice" align="center" label="开通价">
                  <template slot-scope="row">
                    <span style="color: red; font-weight: bold">￥{{ row.row.agentPrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="validDay" width="150" align="center" label="有效期">
                  <template slot-scope="row">{{
                      row.row.validDay ? row.row.validDay + '天' : '不限'
                  }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="subjectCourseName" align="center" label="所属科目"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="60" prop="goodsCount" label="内容"></el-table-column> -->
                <el-table-column prop="createTime" label="操作" align="center" width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.readyBuy != 1" @click="deleteList(scope.row)" class="mainColor">删除</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="table-amount">
                <span>已选商品：{{ subjectList ? subjectList.length : 0 }}</span>
                <span>商品总数量：{{ countNum }}</span>
                <span>合计：￥{{ totals }}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="purchaserType == '学员'" :span="24">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="学员校区" prop="studentGroupId">
              <el-cascader ref="cascaderUnit" clearable v-model="addForm.campusId" :show-all-levels="false" :props="campusTreeProps" placeholder="请选择所属校区" :options="campusList" @change="campusIdChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="purchaserType == '学员'" :span="24">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="校区余额" >
              <el-input placeholder="校区余额" disabled  v-model="campusAmount" style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="purchaserType == '学员'" :span="24">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="开通用户" prop="studentGroupId">
              <el-input v-if="!$route.query.phone" @blur="getMobiles" rows="3" type="textarea" v-model="addForm.name" @keyup.enter.native="getMobiless" placeholder="请输入学员手机号，以空格键分隔"></el-input>
              <el-input v-if="$route.query.phone" v-model="$route.query.phone" type="input" disabled></el-input>
              <span style="font-size: 13px; color: #909399">支持从excel复制一列，解析按空格隔开的手机号</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="purchaserType == '学员'" :span="24">
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label prop="studentGroupId">
              <div class="mobile">
                <span style="width: 160px; display: block" v-for="(item, index) in mobiles" :key="index">
                  <!-- :style="index%2?'':'margin-right: 20px;'" -->

                  <span>{{ item }}</span>
                  <i class="el-icon-delete" @click="deleteMoblie(index)"></i>
                </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="已选用户">
            <span style="font-size: 14px;">{{mobiles?mobiles.length:0}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="已选商品">
            <span style="font-size: 14px;">{{readuNums?readuNums:0}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="支付合计">
            <span style="font-size: 14px;color:#FF646B">￥{{amount}}</span>
          </el-form-item>
        </el-col>
        </el-row>-->
      </el-form>
      <div style="text-align: left; margin-left: 80px">
        <!--  :loading="blockAddSubject" -->
        <el-button type="primary" @click="addSubject">确 定</el-button>
        <el-button type="cancle" @click="Back">取 消</el-button>
      </div>
    </el-card>

    <el-dialog title="添加商品" :visible.sync="addFormVisible" width="70%" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="8" :md="8" :lg="6">
            <el-cascader :show-all-levels="false" ref="tree" placeholder="请选择所属科目" collapse-tags @change="subjectChange" :options="subjectTreeList" :props="subjectTreeProps" clearable></el-cascader>
          </el-col>
          <el-col :sm="8" :md="8" :lg="6">
            <el-select v-model="searchForm.type" clearable placeholder="请选择商品类型">
              <el-option v-for="item in goodsTypeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="8" :md="8" :lg="6">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          </el-col>
          <el-col :sm="5" :md="5" :lg="6" align="right">
            <el-button type="primary" @click="pageList2">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table ref="multipleTables" v-loading="loading" height="400" :data="addFormVisibleList" tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="selectionChange" border>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" width="370" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img style="margin-right: 10px" height="60" width="109" :src="
                          row.row.logo
                            ? row.row.logo
                            : '../../../static/image/noImg.png'
                        " />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color: rgb(77, 148, 255); margin-left: 10px">{{ row.row.name }}</span>
                      <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          ">￥{{ row.row.originalPrice }}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="agentPrice" label="售价">
                <template slot-scope="row">
                  <span style="display: block">
                    <span style="color: red">￥{{ row.row.agentPrice }}</span>
                    <span style="
                        text-decoration: line-through;
                        color: rgb(162, 170, 188);
                      ">￥{{ row.row.price }}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="100"  prop="agentPrice" label="代理价">
                <template slot-scope="row">
                  <span style="color:red;font-weight:bold">￥{{row.row.agentPrice}}</span>
                </template>
              </el-table-column> -->
              <el-table-column show-overflow-tooltip prop="validDay" label="有效期">
                <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + '天' : '不限'
                }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目"></el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="60" prop="goodsCount" label="内容"></el-table-column> -->
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      countIndex: -1,
      purchaserType: '学员',
      nanState: 0,
      countNum: 0,
      orderObjArr: [{
        value: '学员',
        label: '学员'
      }, {
        value: '代理人',
        label: '代理人'
      }],
      subjectTreeList: [], //科目
      totals: 0,
      paySty: -1,
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children"
      },
      addForm: {

      },
      readuNums: 0,
      goodsName: "",
      formLabelWidth: "80px",
      addFormRules: {},
      loading: false,
      value1: false,
      subjectList: [],
      subjectListAdd: [],
      temporaryList: [],
      mobiles: [],
      goodsIds: [],
      alreadySubjectList: [],
      arrsSelect: [],
      amount: 0,
      addFormVisibleList: [],
      addFormVisible: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: []
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      blockAddSubject: false,
      campusTreeProps: {
        value: "id",
        label: "name",
        leaf: "amount",
        children: "children",
      },
      campusList: [],
      campusId: '',
      goodsTypeList: [],
      campusAmount:''//xiaoq
    };
  },
  created () { },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  mounted () {
    this.pageList();
    if (this.$route.query.phone) {
      this.mobiles.push(this.$route.query.phone);
    }
    this.getCampusList();
    this.getGoodsTypeList();
  },
  methods: {
    showCountInput (row) {
      console.log(row);
      if (this.purchaserType == '代理人') {
        this.countIndex = row.$index;
        this.$nextTick(() => {
          this.$refs.inputIndex.focus(); // 自动获取焦点
        })
      }
    },
    purchaserTypeChange () {
      let amount = 0;
      let num = 0;
      if (this.purchaserType == '学员') {
        this.subjectList.forEach(item => { item.goodsCount = 1; amount = amount + item.agentPrice * 1; num++; });
        this.totals = amount;
        this.countNum = num;
      }
    },
    changeCount (row) {
      this.nanState = 0;
      console.log(row.goodsCount, 'row.goodsCount');
      let count = Number(row.goodsCount);
      if (isNaN(count) || row.goodsCount == "") {
        this.$message.warning('请输入数字');
        this.nanState = 1;
        return;
      } else {
        let amount = 0;
        let num = 0;
        this.subjectList.forEach(item => {
          // console.log(item);
          let n = Number(item.goodsCount);
          num += n;
          if (!isNaN(n)) amount = amount + item.agentPrice * n;
          else this.nanState = 1;
        })
        // console.log(this.nanState);
        if (this.nanState == 0) {
          this.totals = amount.toFixed(2);
          this.countIndex = -1;
          this.countNum = num;
        } else this.$message.error('数据错误');
      }
    },

    getGoodsTypeList () {
      this.api.goodsInfo
        .getGoodsTypeList({})
        .then(result => {
          if (result.success) {
            this.goodsTypeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    campusIdChange () {
      //获取阶段
      const checkedNodes = this.$refs['cascaderUnit'].getCheckedNodes();
      if(checkedNodes[0]){
        this.campusAmount = checkedNodes[0].data.amount;
      }else {
        this.campusAmount = '';
      }
      // debugger
      let item = this.addForm.campusId;
      let length = item.length;
      let index = length;
      this.campusId = item[index - 1];

    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    closeDialog () {
      let that = this;
      this.totals = 0;
      let num = 0;
      this.subjectListAdd.forEach(item => {
        let addSty = true;
        this.subjectList.forEach(items => {
          if (items.id == item.id) {
            addSty = false;
          }
        });
        if (addSty) {
          let goods = JSON.parse(JSON.stringify(item));
          this.subjectList.push(goods);
        }
      });
      this.amount = 0;
      this.readuNums = 0;
      this.subjectList.forEach(e => {
        // e.goodsCount = 1;
        this.$set(e, 'goodsCount', 1);
        let n = Number(e.goodsCount);
        num += n;
        that.totals = that.totals + e.agentPrice * n;

        if (e.readyBuy != 1) {
          let amount = that.amount + e.agentPrice * n;
          console.log(amount);
          that.amount = Number(amount.toFixed(2));
          that.readuNums = that.readuNums + 1;
        }
      });
      this.countNum = num;
      this.addFormVisible = false;
    },
    deleteMoblie (index) {
      this.mobiles.splice(index, 1);
    },
    getMobiles () {
      // let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      // if (mobile.test(this.addForm.name)) {
      //   let addSty = true;
      //   this.mobiles.forEach(item => {
      //     if (item == this.addForm.name) {
      //       this.$message.warning(this.addForm.name + "此电话号码已存在！！！");
      //       addSty = false;
      //     }
      //   });
      //   if (addSty) {
      //     this.mobiles.push(this.addForm.name);
      //     this.addForm.name = "";
      //   }
      // } else {
      //   if (this.addForm.name) {
      //     this.$message.error(this.addForm.name + "格式不正确！！！");
      //   }
      // }
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names
        .split("")
        .reverse()
        .join("")
        .split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      // 17714559953 17714559954 17714559956
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
    // getMobiless() {
    //   let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
    //   if (mobile.test(this.addForm.name)) {
    //     let addSty = true;
    //     this.mobiles.forEach(item => {
    //       if (item == this.addForm.name) {
    //         this.$message.warning(this.addForm.name + "此电话号码已存在！！！");
    //         addSty = false;
    //       }
    //     });
    //     if (addSty) {
    //       this.mobiles.push(this.addForm.name);
    //       this.addForm.name = "";
    //     }
    //   } else {
    //     if (this.addForm.name) {
    //       this.$message.error(this.addForm.name + "格式不正确！！！");
    //     }
    //   }

    //   console.log("this.mobiles", this.mobiles);
    // },
    getMobiless () {
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names
        .split("")
        .reverse()
        .join("")
        .split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      // 17714559953 17714559954 17714559956
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
    deleteList (row) {
      this.subjectList.forEach((item, index) => {
        if (row.id == item.id) {
          this.totals = this.totals - item.agentPrice * item.goodsCount;
          this.subjectList.splice(index, 1);
          this.amount = this.amount - item.agentPrice * item.goodsCount;
          this.countNum -= item.goodsCount;
          this.$message.success("移除成功");
        }
      });
    },
    Back () {
      this.$router.go(-1);
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList2();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList2();
    },
    pageList2 () {
      this.loading = true;
      // this.api.goodsInfo
      //   .getGoodsInfoList({ name: this.goodsName })
      //   .then(result => {
      //     this.subjectList.push(result.data[0]);
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.purchaserType = this.purchaserType;
      // this.purchaserType == '学员' ? this.searchForm.purchaserType = 1 : this.searchForm.purchaserType = 2;
      // this.api.goodsInfo
      //   .pageListHasAgentPrice(this.searchForm)
      //   .then(result => {
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.addFormVisibleList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
          this.addFormVisibleList.forEach((item, index) => {
            let sty = true;
            this.subjectList.forEach(items => {
              if (item.id == items.id) {
                sty = false;
                this.$nextTick(() => this.$refs.multipleTables.toggleRowSelection(this.addFormVisibleList[index]))
              }
            });
            if (!sty) {
              this.arrsSelect.push(item);
            }
          });
        })
        // .then(res => {
        //   let that = this;
        //   if (this.addFormVisible) {
        //     that.$nextTick(function () {
        //       if (that.arrsSelect) {
        //         that.arrsSelect.forEach((row, index) => {
        //           that.$refs.multipleTables.toggleRowSelection(
        //             this.addFormVisibleList[index],
        //             true
        //           );
        //         });
        //       }
        //     });
        //   }
        //   that.webLoading2 = false;
        // })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange (val) {
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach(item => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    pageList () {
      if (this.$route.query.id) {
        this.api.goodsInfo
          .getStudentBuyGoodsList({ id: this.$route.query.id })
          .then(result => {
            this.loading = false;
            if (result.data) {
              result.data.forEach(item => {
                item.readyBuy = 1;
              });
              this.subjectList = result.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
        this.api.goodsInfo
          .getStudentBuyGoodsList({ id: this.$route.query.id })
          .then(result => {
            this.alreadySubjectList = result.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    selectionChange (val) {
      this.subjectListAdd = val;
    },
    addSubject () {
      let obj = {};
      if (this.blockAddSubject) {
        return false;
      }
      setTimeout(function () {
        this.blockAddSubject = false;
      }, 5000);
      this.blockAddSubject = true;
      this.goodsIds = [];
      // console.log(1, this.alreadySubjectList.length);
      // console.log(2, this.subjectList.length);
      this.subjectList.forEach(item => {
        let sty = true;
        this.alreadySubjectList.forEach(e => {
          if (e.id == item.id) {
            sty = false;
          }
        });
        if (sty) {
          this.goodsIds.push({ goodsId: item.id, goodsQuantity: item.goodsCount });
        }
      });
      if (this.purchaserType == '学员') {
        if (this.mobiles.length == 0) {
          this.blockAddSubject = false;
          return this.$message.error("请选择开通用户！");
        }
        if (this.goodsIds.length == 0) {
          this.blockAddSubject = false;
          return this.$message.error("请选择商品！");
        }
        if (this.campusId.length == 0) {
          this.blockAddSubject = false;
          return this.$message.error("请选择校区！");
        }
        obj = {
          purchaserType: this.purchaserType,
          mobileList: this.mobiles,
          orderItemList: this.goodsIds,
          campusId: this.campusId
        }
      } else if (this.purchaserType == '代理人') {
        obj = {
          purchaserType: this.purchaserType,
          orderItemList: this.goodsIds,
        }
      }
      console.log(obj, 'objobjobj');
      this.api.addOrderInfoBatchByMobilesPay(obj)
        .then(result => {
          if (result.success) {
            if (result.data) {
              this.$message.success(result.message);
              this.blockAddSubject = false;
            } else {
              this.$message.warning(result.message);
              this.blockAddSubject = false;
            }

            this.Back();
          } else {
            this.blockAddSubject = false;
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openaddFormVisible () {
      this.addFormVisible = true;
      this.pageList2();
      this.api.getSubjectTreeList().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              delete items.children;
              // if (items.children.length != 0) {
              //   for (let itemss of items.children) {
              //     delete itemss.children;
              //   }
              // } else {
              //   // delete items.children;
              // }
            }
          } else {
            // delete item.children;
          }
        }
        this.subjectTreeList = result.data;
      }).catch(error => {
        console.log(error);
      });
    }
  },
  watch: {
    subjectList (val) {
      console.log(val);
    },
    addFormVisible (val) {
      if (!val) {
        this.searchForm = {
          sell: 1,
          name: ""
        };
        this.page = {
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: ""
        };
        this.subjectListAdd = [];
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.addOrders {
  .tabs .el-form-item__content {
    line-height: 22px !important;
  }

  .mobile {
    height: auto;
    max-width: 400px;
    font-size: 14px;
    flex-wrap: wrap;
    display: flex;

    span {}
  }

  .table-amount {
    height: 40px;
    width: 100%;
    border: 1px solid #d9ebf5;
    box-sizing: border-box;
    border-top: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px;
    color: #333333;
    font-weight: bold;

    span {
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/addOrders.vue